import React from 'react'
import { Alert } from 'react-bootstrap'
import { useAppContext } from 'state/context'

export const NoticesDisplay = () => {
  const [{ notices }] = useAppContext()

  return (
    <div id="notices">
      {notices.map((notice, i) => (
        <Alert key={i} variant="primary" className="primary-alert">
          {notice}
        </Alert>
      ))}
    </div>
  )
}
